import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs';
/**
 * THe servie to load the Households
 */
@Injectable({
  providedIn: 'root'
})
export class HouseholdService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Get the Count of all Households with x count of adultMembers
   * @param adultMembers 
   * @returns 
   */
  getHouseHoldsWithAdultMembersCount(adultMembers: number) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/businessuser/group?adultMembers=${adultMembers}`)
      )
    )
  }
  /**
   * Get the Count of all Households with x count of adultMembers
   * @param adultMembers 
   * @returns 
   */
  getHouseHoldsWithAdultMembers(adultMembers: number) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/businessuser/group?adultMembers=${adultMembers}`, {})
      )
    )
  }
  /**
   * Set the User to neverdeactivate
   * @param publicId 
   * @param neverdeactivate 
   * @returns 
   */
  neverdeactivateUserById(publicId: String, neverdeactivate: boolean) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/caseworker/household/${publicId}?neverdeactivate${neverdeactivate}`, {})
      )
    )
  }
  /**
   * Deactivate the User by ID
   * @param publicId 
   * @returns 
   */
  deactivateRequestUserById(publicId: String) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/caseworker/household/${publicId}/disablerequest `, {})
      )
    )
  }
  /**
   * Reactivate the User by ID
   * @param publicId 
   * @returns 
   */
  reactivateUserById(publicId: String) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/caseworker/household/${publicId}/reactivate `, {})
      )
    )
  }
  /**
   * Create the disablerequest for the User by ID
   * @param publicId 
   * @returns 
   */
  disablerequestUserById(publicId: String) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/caseworker/household/${publicId}/disablerequest `, {})
      )
    )
  }
  /**
   * Deactivate the User by ID
   * @param publicId 
   * @returns 
   */
  deactivateUserById(publicId: String) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/caseworker/household/${publicId}/deactivate `, {})
      )
    )
  }

}
